import { render } from "./StringComponent.vue?vue&type=template&id=4a2c24d6&scoped=true"
import script from "./StringComponent.vue?vue&type=script&lang=js"
export * from "./StringComponent.vue?vue&type=script&lang=js"

import "./StringComponent.vue?vue&type=style&index=0&id=4a2c24d6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4a2c24d6"

export default script